import React, { Component, useCallback } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn } from "../../Components/InputElements";
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime, decodeData } from '../../Constants/constants';
class States extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            state_id: 0,
            pt_lwf_state_id: 0,
            state_title: '',
            state_code: '',
            pt_lwf_state_title: '',
            pt_lwf_state_code: '',
            keyword: '',
            pt_lwf_keyword: '',
            state_switch: false,
            rows: [],
            pt_lwf_rows:[],
            errors: {},
            pt_lwf_errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            pt_lwf_next: false,
            pt_lwf_prev: false,
            pt_lwf_page: 1,
            pt_lwf_limit: 10,
            pt_lwf_total_records: 0,
            pt_lwf_total_pages: 0,
            loadingList: false,
            loadingPost: false,
            isStateModal:false,
            isPtLwfStateModal:false,
            have_to_create_pt_lwf_state:"0",
            decodedData: [],
        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetPtLwfList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === 'state_code') {
            newValue = value.toUpperCase();
        }

        this.setState((prevState) => ({
            [name]: newValue,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }),()=>{
            if(this.state.location_switch && name === "pt_lwf_keyword" && !value) this.GetPtLwfList();
            else if(!this.state.location_switch && name === "keyword" && !value) this.GetList();
        });
    };

    handleInputSearch = (isPtLwf) => {
        if(isPtLwf==="pt_lwf"){
         this.GetPtLwfList()
        }
        else{
            this.GetList();
        }
        
    }
    handleClearAll = (isPtLwf) => {
        if(isPtLwf==="pt_lwf"){
            this.setState({
                // pt_lwf_rows: [],
                // pt_lwf_next: false,
                // pt_lwf_prev: false,
                // pt_lwf_page: 1,
                // pt_lwf_limit: 10,
                // pt_lwf_total_records: 0,
                // pt_lwf_total_pages: 0,
                // pt_lwf_loadingList: false,
                // loadingPost: false,
                pt_lwf_keyword: "",
            }
                , () => {
                    this.GetPtLwfList();
                });
        }
        else{
            this.setState({
                // rows: [],
                // next: false,
                // prev: false,
                // page: 1,
                // limit: 10,
                // total_records: 0,
                // total_pages: 0,
                // loadingList: false,
                // loadingPost: false,
                keyword: "",
            }
                , () => {
                    this.GetList();
                });
        }
        
    };


    GetInfo = (row,isPtLwf) => {
        // const { apiURL, apiHeaderJSON } = this.context;
        // const headers = apiHeaderJSON;
        // axios.get(`${apiURL}Masters/GetStateInfo?state_id=${this.state.state_id}`, { headers }).then((response) => {
        //     const { data, success } = response.data;
        //     if (success === true) {
        //         this.setState(
        //             {
        //                 state_title: data[0].state_title,
        //                 state_code: data[0].state_code,

        //             }
        //         )
        //     }
        // });
        if(isPtLwf==="pt_lwf"){
            this.setState(
                {
                    pt_lwf_state_title: row?.pt_lwf_state_title,
                    pt_lwf_state_code: row?.pt_lwf_state_code,
                    state_title: "",
                    state_code: "",
                    isStateModal:false,
                    isPtLwfStateModal:true,
                });
        }
        else{
            this.setState(
                {
                    state_title: row?.state_title,
                    state_code: row?.state_code,
                    pt_lwf_state_title:"",
                    pt_lwf_state_code:"",
                    isStateModal:true,
                    isPtLwfStateModal:false,

                });
        }
        

    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetStates`, { params: { limit: this.state.limit, page: this.state.page, keyword: this.state.keyword }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetPtLwfList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetPTAndLWFStateList`, { params: { limit: this.state.pt_lwf_limit, page: this.state.pt_lwf_page, keyword: this.state.pt_lwf_keyword }, headers }).then((response) => {
            var data = response.data;
            console.log("GetPTAndLWFStateList",data)
            if (response.data.success === true) {
                this.setState({
                    pt_lwf_rows: data?.data || [],
                    pt_lwf_next: data.next,
                    pt_lwf_prev: data.prev,
                    pt_lwf_page: data.page,
                    pt_lwf_total_records: data.total_records,
                    pt_lwf_total_pages: data.total_pages,
                    pt_lwf_loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ loadingPost:false, errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            state_title: this.state.state_title,
            state_code: this.state.state_code,
            date: currentDateAndTime(),
        }
        if (this.state.state_id !== 0) {
            formData.state_id = this.state.state_id;
        }
        if (this.state.state_id === 0) {
            formData.have_to_create_pt_lwf_state = this.state.have_to_create_pt_lwf_state || "0";
        }

        axios
            .post(`${apiURL}Masters/CreateState`, formData, { headers })
            .then((response) => {
                console.log(`response`, response);
                const { success } = response.data;
                if (success === true) {
                    
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false
                    });
                    this.resetForm();
                    this.setState({loadingPost: false, loadingList: true }, (prevState) => {
                        this.GetList();
                        this.GetPtLwfList();
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false
                    })
                    this.setState({ loadingPost: false, loadingList: true });
                }

            })
    };
    handleSubmitPtLwfState = (e) => {
        e.preventDefault();
        const errors = this.validateForm("pt_lwf");
        console.log("errors",errors);
        if (Object.keys(errors).length > 0) {
            this.setState({ loadingPost:false, errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            pt_lwf_state_title: this.state.pt_lwf_state_title,
            pt_lwf_state_code: this.state.pt_lwf_state_code,
        }
        if (this.state.pt_lwf_state_id !== 0) {
            formData.pt_lwf_state_id = this.state.pt_lwf_state_id;
        }

        axios
            .post(`${apiURL}Masters/CreateUpdatePTAndLWFState`, formData, { headers })
            .then((response) => {
                console.log(`response`, response);
                const { success } = response.data;
                if (success === true) {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false
                    });
                    this.resetForm();
                    this.setState({ loadingPost: false, loadingList: true }, (prevState) => {
                        this.GetList();
                        this.GetPtLwfList();
                    });
                } else {
                    this.setState({ loadingPost: false, loadingList: true });
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false
                    })
                    
                }

            })
    };
    resetForm = () => {
        this.setState({
            state_id: 0,
            state_title: '',
            state_code: '',
            pt_lwf_state_id: 0,
            pt_lwf_state_title: '',
            pt_lwf_state_code: '',
            isStateModal:false,
            isPtLwfStateModal:false,
        })
    }
    validateForm = (isPtLwf) => {
        const errors = {};

        if(isPtLwf==="pt_lwf"){
            if (!this.state.pt_lwf_state_title) {
                errors.pt_lwf_state_title = 'State title is required';
            }
            if (!this.state.pt_lwf_state_code) {
                errors.pt_lwf_state_code = 'State code is required';
            }
        }
        else{
            if (!this.state.state_title) {
                errors.state_title = 'State title is required';
            }
            if (!this.state.state_code) {
                errors.state_code = 'State code is required';
            }
        }
        return errors;
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    state_id: id,
                    date: currentDateAndTime(),
                    
                };
                axios
                    .post(`${apiURL}Masters/DeleteState`, formData, {
                        params:{
                            state_id: id
                        },
                         headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                    });
            }
        });
    }
    handleDeletePtLwf = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    pt_lwf_state_id: id
                };
                axios
                    .post(`${apiURL}Masters/DeletePTAndLWFState`, formData, {
                        params:{
                            pt_lwf_state_id: id
                        },
                          headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                // this.GetList();
                                this.GetPtLwfList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false
                        })
                    });
            }
        });
    }

    handlePrev = (e,type) => {
        const name= type==="1"? "page":"pt_lwf_page"
        console.log("name,type",name,type);
        console.log(this.state.prev);
        if ((this.state.prev === true) || (this.state.pt_lwf_prev === true)) {
            this.setState({
            [name]:  type==="1"?  this.state.page - 1 : this.state.pt_lwf_page - 1
            }, () => {
                console.log("this.state.page",this.state.page);
                console.log("this.state.pt_lwf_page",this.state.pt_lwf_page);
                if(type==="1"){
                    this.GetList();   
                }
                else{
                    this.GetPtLwfList();
                }
            });
        }
    }
    handleNext = (e,type) => {
        const name= type==="1"? "page":"pt_lwf_page"
        console.log("name,type",name,type);
        if ((this.state.next === true) || (this.state.pt_lwf_next === true)) {
            this.setState({
               [name]: type==="1"?  this.state.page + 1 : this.state.pt_lwf_page + 1
            }, () => {
                console.log("this.state.page",this.state.page);
                console.log("this.state.pt_lwf_page",this.state.pt_lwf_page);
                if(type==="1"){
                 this.GetList();   
                }
                else{
                    this.GetPtLwfList();
                }
            });
        }
    }
    handleChange = (e,type) => {
        const name= type==="1"? "page":"pt_lwf_page"
        const { value } = e.target;
        this.setState((prevState) => {
            return { [name]: parseInt(value) };
        }, () => {
            if(type==="1"){
             this.GetList();       
            }
            else{
                this.GetPtLwfList();
            }
        });
    }
    handleLimitChange = (e,type) => {
        const name= type==="1"? "limit":"pt_lwf_limit"
        const { value } = e.target;
        this.setState((prevState) => {
            return { [name]: parseInt(value) };
        }, () => {
            if(type==="1"){
             this.GetList();       
            }
            else{
                this.GetPtLwfList();
            }
        });
    };

    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`State Master`} primary={`Home`} />
                        <div className='card'>
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">{!this.state.state_switch? " State":" PT & LWF State"}</h4>
                            <button  className={`btn btn-info btn-label`} 
                            disabled={this.state.loadingPost}
                            onClick={() => { 
                                if(!this.state.loadingPost){
                                    this.setState({state_switch :!this.state.state_switch})
                            }}} >
                                <i className={` ri-switch-line label-icon align-middle fs-16 ms-2`} />
                                {this.state.state_switch? " State":" PT & LWF State"}</button>
                        </div>
                        {!this.state.state_switch?
                         <div className="row">
                            <div className="col-md-12">
                                <div className=''>
                                    <div className=" card-body align-items-end justify-content-between d-flex">
                                        <div className='  '>
                                            <label htmlFor="keyword">State Title</label>
                                            <div className="input-group">
                                                <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by state title" />
                                                <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={this.handleClearAll} type="button" id="button-addon2">Clear</button>
                                            </div>
                                        </div>
                                        { this.state.decodedData?.includes(2) && (
                                        <div className=''>
                                            <button style={{ float: "right"}} onClick={()=>{ this.setState({ state_id:0, isStateModal:true, isPtLwfStateModal:false }) }} className={`btn btn-success btn-label `} >
                                                <span className="d-flex align-items-center gap-1">
                                                <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                                Add
                                            </span>
                                            </button>
                                        </div>)}
                                    </div>
                                    <div className="col-md-12 card-body ">
                                        <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                            <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                <tr>
                                                    <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                                    <th>State Title</th>
                                                    <th>State Code</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            {this.state.rows?.length===0?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={5}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody>:
                                            <tbody>
                                                {
                                                    this.state.rows.map((row,idx) => {
                                                        return <tr key={row.state_id}>
                                                            <td className=' text-center'>{idx+1}</td>
                                                            <td>{row.state_title}</td>
                                                            <td>{row.state_code}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => this.setState({ state_id: row.state_id }, (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                    <button onClick={() => this.handleDelete(row.state_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>}
                                            {this.state.rows?.length>0 && (
                                                <tfoot className='table-light'>
                                                    <tr>
                                                        <th colSpan={5} >
                                                            <div className="d-flex justify-content-between" >
                                                                <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} name='prev' type="button" onClick={(e) => this.handlePrev(e,"1")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {
                                                                        <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                    }
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <select name='total_pages' className="form-select" onChange={(e) => this.handleChange(e,"1")}>
                                                                        {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                            <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <select name='total_records' onChange={(e) => { this.handleLimitChange(e,"1") }} className="form-select"  value={this.state.limit} >
                                                                        <option value={`${this.state.rows?.length}`}>All</option>
                                                                        <option value="10">Limit 10</option>
                                                                        <option value="25">Limit 25</option>
                                                                        <option value="50">Limit 50</option>
                                                                        <option value="100">Limit 100</option>
                                                                        <option value="200">Limit 200</option>
                                                                        <option value="500">Limit 500</option>
                                                                    </select>
                                                                </div>
                                                                <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} name='next' type="button" onClick={(e) => this.handleNext(e,"1")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>:
                        <div className="row">
                            <div className="col-md-12">
                                <div className=''>
                                <div className=" card-body align-items-end justify-content-between d-flex">
                                        <div className='  '>
                                            {/* <label htmlFor="keyword"></label> */}
                                            <label htmlFor="keyword">PT & LWF State Title</label>
                                            <div className="input-group">
                                                <input type="search" className="form-control" onChange={this.handleInputChange} name="pt_lwf_keyword" value={this.state.pt_lwf_keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by state title" />
                                                <button className="btn btn-success" disabled={!this.state.pt_lwf_keyword} onClick={()=>this.handleInputSearch("pt_lwf")} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                <button className="btn btn-secondary ms-3" disabled={!this.state.pt_lwf_keyword} onClick={() =>this.handleClearAll("pt_lwf")} type="button" id="button-addon2">Clear</button>
                                            </div>
                                        </div>
                                        { this.state.decodedData?.includes(2) && (
                                        <div className=''>
                                            <button style={{ float: "right"}} onClick={()=>{ this.setState({ state_id:0, isStateModal:true, isPtLwfStateModal:false }) }} className={`btn btn-success btn-label `} >
                                                <span className="d-flex align-items-center gap-1">
                                                <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                                Add
                                            </span>
                                            </button>
                                        </div>)}
                                    </div>
                                    {/* <div className=" card-body align-items-end justify-content-between d-flex">
                                        <div className=''>
                                            <label htmlFor="keyword">PT & LWF State Title</label>
                                            <div className="input-group">
                                                <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by state title" />
                                                <button className="btn btn-success" onClick={()=>{this.handleInputSearch("pt_lwf")}} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={()=>{this.handleClearAll("pt_lwf")}} type="button" id="button-addon2">Clear</button>
                                            </div>
                                        </div>
                                        { this.state.decodedData?.includes(2) && (
                                        <div className=''>
                                            <button style={{ float: "right"}} onClick={()=>{ this.setState({ isStateModal:false, isPtLwfStateModal:true }) }} className={`btn btn-success btn-label `} >
                                                <span className="d-flex align-items-center gap-1">
                                                <i className={` ri-play-list-add-line label-icon align-middle fs-16 ms-2`} />
                                                Add
                                            </span>
                                            </button>
                                        </div>)}
                                    </div> */}
                                    <div className="col-md-12 card-body ">
                                        <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                            <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                <tr>
                                                    <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                                    <th>PT & LWF State Title</th>
                                                    <th>PT & LWF State Code</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            {this.state.pt_lwf_rows?.length===0?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={5}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody>:
                                            <tbody>
                                                {
                                                    this.state.pt_lwf_rows?.map((row,idx) => {
                                                        return <tr key={row.pt_lwf_state_id}>
                                                            <td className=' text-center'>{ idx + 1 }</td>
                                                            <td>{row.pt_lwf_state_title}</td>
                                                            <td>{row.pt_lwf_state_code}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => this.setState({ pt_lwf_state_id: row.pt_lwf_state_id }, (prevState) => this.GetInfo(row,"pt_lwf"))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                    <button onClick={() => this.handleDeletePtLwf(row.pt_lwf_state_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            }
                                            {this.state.pt_lwf_rows?.length>0 && (
                                                <tfoot className='table-light'>
                                                    <tr>
                                                        <th colSpan={5} >
                                                            <div className="d-flex justify-content-between" >
                                                                <button disabled={this.state.pt_lwf_prev === false && this.state.loadingList === false ? true : false} type="button" name='pt_lwf_prev' onClick={(e) => this.handlePrev(e,"2")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {
                                                                        <small>Total Records: {this.state.pt_lwf_total_records} | Total Pages: {this.state.pt_lwf_total_pages} | Current Page: {this.state.pt_lwf_page}</small>
                                                                    }
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <select className="form-select" name='pt_lwf_total_pages' onChange={(e) => this.handleChange(e,"2")}>
                                                                        {Array.from({ length: this.state.pt_lwf_total_pages }, (_, i) => (
                                                                            <option selected={this.state.pt_lwf_page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <select name='pt_lwf_total_records' onChange={(e) => { this.handleLimitChange(e,"2") }} className="form-select" value={this.state.pt_lwf_limit} >
                                                                        <option value={`${this.state.pt_lwf_rows?.length}`}>All</option>
                                                                        <option value="10">Limit 10</option>
                                                                        <option value="25">Limit 25</option>
                                                                        <option value="50">Limit 50</option>
                                                                        <option value="100">Limit 100</option>
                                                                        <option value="200">Limit 200</option>
                                                                        <option value="500">Limit 500</option>
                                                                    </select>
                                                                </div>
                                                                <button disabled={this.state.pt_lwf_next === false && this.state.loadingList === false ? true : false} name='pt_lwf_next' type="button" onClick={(e) => this.handleNext(e,"2")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            )}
                                            
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        } 
                        </div>
                        {this.state.isStateModal && (
                            <div id="myModal" className="modal show" tabIndex={-1} style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }}
                                aria-labelledby="myModalLabel"
                                aria-hidden="true"
                            >
                                <div
                                className=" bg-light m-auto mt-3"
                                style={{ width: "40%" }}
                                >
                                <div className="modal-content">
                                    <div
                                    style={{ padding: "10px 10px 0 10px" }}
                                    className="modal-header"
                                    >
                                        <h5 className="modal-title" id="myModalLabel">
                                            State
                                        </h5>
                                        <button
                                            onClick={() => {
                                                if(!this.state.loadingPost){
                                                    this.setState({ isStateModal:!this.state.isStateModal },()=> this.resetForm())
                                                }
                                            }}
                                            className="btn-close"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div
                                            style={{ padding: "10px 0px 0 0px" }}
                                            className="card-body form-steps"
                                        >
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form 
                                                onSubmit={(e) => {
                                                    console.log("this.state.loadingPost",this.state.loadingPost);
                                                    if(!this.state.loadingPost){
                                                        this.setState({loadingPost:true},()=>{
                                                            this.handleSubmit(e);
                                                        });
                                                    }
                                                }} 
                                                className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="state_title" className="form-label">State Title</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.state_title ? 'is-invalid' : ''}`}
                                                            id="state_title"
                                                            name="state_title"
                                                            value={this.state.state_title}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter state title"
                                                        />
                                                        {errors.state_title && <div className="text-danger">{errors.state_title}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="state_code" className="form-label">State Code</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.state_code ? 'is-invalid' : ''}`}
                                                            id="state_code"
                                                            name="state_code"
                                                            value={this.state.state_code}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter state code"
                                                        />
                                                        {errors.state_code && <div className="text-danger">{errors.state_code}</div>}
                                                    </div>
                                                    {this.state.state_id == 0 && (
                                                        <div className="col-md-12 mt-3 settings-sectio">
                                                        {/* <label htmlFor="state_code" className="form-label"></label> */}
                                                            <div className="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="checkbox"
                                                                    id="have_to_create_pt_lwf_state"
                                                                    name="have_to_create_pt_lwf_state"
                                                                    className="form-check-input"
                                                                    value="1"
                                                                    checked={this.state.have_to_create_pt_lwf_state == '1'}
                                                                    onChange={(e) => {this.setState({ have_to_create_pt_lwf_state: e.target.checked ? "1" : "0" })}}
                                                                />
                                                                <label htmlFor="have_to_create_pt_lwf_state" className="form-check-label ms-2">Create PT And LWF State</label>
                                                                {errors.have_to_create_pt_lwf_state && <div className="text-danger">{errors.have_to_create_pt_lwf_state}</div>}
                                                            </div>
                                                        </div>
                                                    ) }
                                                    

                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            this.state.state_id !== 0 ? 
                                                            <button type="submit" className={`btn btn-primary ${!this.state.loadingPost && "btn-label"} `} >
                                                                <span className="d-flex align-items-center gap-1">
                                                                {this.state.loadingPost ? (
                                                                <span
                                                                  class="spinner-border flex-shrink-0 "
                                                                  role="status"
                                                                  style={{
                                                                    width: "1.2rem",
                                                                    height: "1.2rem",
                                                                    borderWidth: "2px",
                                                                    }}
                                                                >
                                                                  <span class="visually-hidden">Loading...</span>
                                                                </span>
                                                              ) : (
                                                                <i className={` ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                              )}
                                                            {this.state.loadingPost ? "Updating...":"Update"}
                                                            </span>
                                                            </button> : 
                                                            <button type="submit" className={`btn btn-primary ${!this.state.loadingPost && "btn-label"} `} >
                                                                <span className="d-flex align-items-center gap-1">
                                                                {this.state.loadingPost ? (
                                                                <span
                                                                  class="spinner-border flex-shrink-0"
                                                                  role="status"
                                                                  style={{
                                                                    width: "1.2rem",
                                                                    height: "1.2rem",
                                                                    borderWidth: "2px",
                                                                    }}
                                                                >
                                                                  <span class="visually-hidden">Loading...</span>
                                                                </span>
                                                              ) : (
                                                                <i className={` ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                              )}
                                                            {this.state.loadingPost ? "Saving...":"Save"}
                                                            </span>
                                                            </button>
                                                        }

                                                        {
                                                            this.state.state_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light btn-label`} 
                                                            onClick={() => {
                                                                if(!this.state.loadingPost){
                                                                    this.resetForm();
                                                                }}} >Close</button> : <div></div>
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            )}
                        {this.state.isPtLwfStateModal && (
                            <div id="myModal" className="modal show" tabIndex={-1} style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }}
                                aria-labelledby="myModalLabel"
                                aria-hidden="true"
                            >
                                <div
                                className=" bg-light m-auto mt-3"
                                style={{ width: "40%" }}
                                >
                                <div className="modal-content">
                                    <div
                                    style={{ padding: "10px 10px 0 10px" }}
                                    className="modal-header"
                                    >
                                        <h5 className="modal-title" id="myModalLabel">
                                            State
                                        </h5>
                                        <button
                                            onClick={() => {
                                                if(!this.state.loadingPost){
                                                    this.setState({ isPtLwfStateModal:!this.state.isPtLwfStateModal },()=> this.resetForm())
                                                }
                                            
                                            }}
                                            className="btn-close"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div
                                            style={{ padding: "10px 0px 0 0px" }}
                                            className="card-body form-steps"
                                        >
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form 
                                                onSubmit={(e) => {
                                                    console.log("this.state.loadingPost",this.state.loadingPost);
                                                    if(!this.state.loadingPost){
                                                        this.setState({loadingPost:true},()=>{
                                                            this.handleSubmitPtLwfState(e);
                                                        });
                                                    }
                                                }} 
                                                className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="pt_lwf_state_title" className="form-label">PT & LWF State Title</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.pt_lwf_state_title ? 'is-invalid' : ''}`}
                                                            id="pt_lwf_state_title"
                                                            name="pt_lwf_state_title"
                                                            value={this.state.pt_lwf_state_title}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter state title"
                                                        />
                                                        {errors.pt_lwf_state_title && <div className="text-danger">{errors.pt_lwf_state_title}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="pt_lwf_state_code" className="form-label">PT & LWF State Code</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.pt_lwf_state_code ? 'is-invalid' : ''}`}
                                                            id="pt_lwf_state_code"
                                                            name="pt_lwf_state_code"
                                                            value={this.state.pt_lwf_state_code}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter state code"
                                                        />
                                                        {errors.pt_lwf_state_code && <div className="text-danger">{errors.pt_lwf_state_code}</div>}
                                                    </div>
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            this.state.pt_lwf_state_id !== 0 ? 
                                                            <button type="submit" className={`btn btn-primary ${!this.state.loadingPost && "btn-label"} `} >
                                                                <span className="d-flex align-items-center gap-1">
                                                                {this.state.loadingPost ? (
                                                                <span
                                                                  class="spinner-border flex-shrink-0"
                                                                  role="status"
                                                                  style={{
                                                                    width: "1.2rem",
                                                                    height: "1.2rem",
                                                                    borderWidth: "2px",
                                                                    }}
                                                                >
                                                                  <span class="visually-hidden">Loading...</span>
                                                                </span>
                                                              ) : (
                                                                <i className={` ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                              )}
                                                            {this.state.loadingPost ? "Updating...":"Update"}
                                                            </span>
                                                            </button> : 
                                                            <button type="submit" className={`btn btn-primary ${!this.state.loadingPost && "btn-label"} `} >
                                                                <span className="d-flex align-items-center gap-1">
                                                                {this.state.loadingPost ? (
                                                                <span
                                                                  class="spinner-border flex-shrink-0"
                                                                  role="status"
                                                                  style={{
                                                                    width: "1.2rem",
                                                                    height: "1.2rem",
                                                                    borderWidth: "2px",
                                                                    }}
                                                                >
                                                                  <span class="visually-hidden">Loading...</span>
                                                                </span>
                                                              ) : (
                                                                <i className={` ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                              )}
                                                            {this.state.loadingPost ? "Saving...":"Save"}
                                                            </span>
                                                            </button>
                                                        }

                                                        {
                                                            this.state.pt_lwf_state_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light`} 
                                                            onClick={() => {
                                                                if(!this.state.loadingPost){
                                                                    this.resetForm();
                                                                }}} >{" "}Close</button> : <div></div>
                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="modal-footer px-0">
                                    {!this.state.loadingAttednace ?
                                        <button type="button"
                                            className={`btn noWrap btn-success btn-label waves-effect waves-light ${this.state.loadingAttednace ? 'disabled' : ''}`}
                                            onClick={()=>{ this.handleAttendance()}}
                                        >
                                            <i className=" ri-git-repository-line label-icon align-middle fs-16 me-2"></i> {!this.state.loadingAttednace ? "Process" : "Processing..."}</button> :
                                        <button className="btn btn-success btn-load">
                                            <span className="d-flex align-items-center">
                                                <span className="spinner-border flex-shrink-0" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </span>
                                                <span className="flex-grow-1 ms-2">
                                                    Processing...
                                                </span>
                                            </span>
                                        </button>}
                                    </div> */}
                                    </div>
                                </div>
                                </div>
                            </div>
                            )}
                    </div>
                </div>
            </div>
        )
    }; s
}
export default withRouter(States);



